import { render, staticRenderFns } from "./LoanAdvisoryCount.vue?vue&type=template&id=4ff08fc1"
import script from "./LoanAdvisoryCount.vue?vue&type=script&lang=js"
export * from "./LoanAdvisoryCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports